// Modifier A section questionnaire constants
export enum ModifierAQuestionnaireItem {
  MODIFIER_A_1_QUESTION = 'modifier-a/1/question',
  MODIFIER_A_1_NOTES = 'modifier-a/1/notes',
  MODIFIER_A_2_QUESTION = 'modifier-a/2/question',
  MODIFIER_A_2_NOTES = 'modifier-a/2/notes',
  MODIFIER_A_3_QUESTION = 'modifier-a/3/question',
  MODIFIER_A_3_NOTES = 'modifier-a/3/notes',
  MODIFIER_A_4_QUESTION = 'modifier-a/4/question',
  MODIFIER_A_4_NOTES = 'modifier-a/4/notes'
}
